import { FeatureFlag } from '../../../gameConfig/sharedTypes';
import { useRandomComponent } from '../../scripts/hooks/useRandomComponent';
import { useFeature, useSpecBySlug } from '../../scripts/selectors/global';
import { LinkSharingSpecGuideAdVariant2 } from './linkSharing/linkSharingSpecGuideAdVariant2';
import { TLinkSharingSpecGuideAdProps, TLinkSharingSpecGuideAdVariantProps } from './linkSharingAd';
import { ComponentType, PropsWithChildren, createElement } from 'react';
import { LinkSharingRemixGuideAdVariant1 } from './linkSharing/linkSharingRemixGuideAdVariant1';

enum GuideType {
  None = 'none',
  Spec = 'spec',
  LegionRemix = 'legion_remix'
}

const useIcyVeinsGuideUrl = (props: TLinkSharingSpecGuideAdProps): [GuideType, string] => {
  if (props.season?.includes('legion-remix')) {
    return [GuideType.LegionRemix, 'https://www.icy-veins.com/wow/legion-remix-guide'];
  } else if (props.class && props.spec) {
    const specData = useSpecBySlug(props.spec, props.class);
    if (specData.spec) {
      let role = 'dps';
      if (specData.spec.role === 'healer') {
        role = 'healing';
      } else if (specData.spec.role === 'tank') {
        role = 'tank';
      }

      return [GuideType.Spec, `https://www.icy-veins.com/wow/${props.spec}-${props.class}-pve-${role}-guide`];
    }

    // fall through
  }

  return [GuideType.None, ''];
};

const VARIANTS: Record<GuideType, ComponentType<TLinkSharingSpecGuideAdVariantProps>[]> = {
  [GuideType.None]: [],
  [GuideType.Spec]: [LinkSharingSpecGuideAdVariant2],
  [GuideType.LegionRemix]: [LinkSharingRemixGuideAdVariant1]
};

export const LinkSharingSpecGuideAd = (props: PropsWithChildren<TLinkSharingSpecGuideAdProps>) => {
  const isActive = useFeature('show_link_sharing_guides' as FeatureFlag);
  const guideInfo = useIcyVeinsGuideUrl(props);
  const [guideType, guideUrl] = guideInfo || [];
  const variantComponent = useRandomComponent(VARIANTS[guideType] || []);

  if (!variantComponent || !guideUrl || !isActive) {
    return null;
  }

  const elem = createElement(variantComponent, { guideUrl, ...props });

  if (props.wrapperClasses) {
    return <div className={props.wrapperClasses}>{elem}</div>;
  } else {
    return elem;
  }
};
